// extracted by css-extract-rspack-plugin
export default {"cls1":"NewsInteractionBar-cls1_MEM","cls2":"NewsInteractionBar-cls2_fxs NewsInteractionBar-cls1_MEM"};